import React, { Fragment, useRef } from 'react'
import { Table, TableBody, TableCell, TableContainer,
   TableHead, TableRow, Paper, TablePagination} from '@mui/material';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import * as XLSX from 'xlsx'
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PrintIcon from "@mui/icons-material/Print";
import Popup from 'reactjs-popup';
import PopupTable from '../PopupTable';
import {HeadingWrap, Span, CommonButton } from '../../Styles/CommonStyles';
import {TableContStyle, TableHeadStyle } from '../../Styles/TableStyles';
import ExcelDownload from '../../data/exceldownload';
import { useAddBulkbrandmasterMutation, useAddNewbrandmasterMutation, useDeletebrandmasterMutation, useGetbrandmasterQuery, useUpdatebrandmasterMutation } from '../../features/brandmaster/brandmasterApiSlice';
import { useGetfinalpdfformQuery} from '../../features/finalpdfforms/finalpdfformsApiSlice';
import MergeAndPrintPdfs from '../../data/mergeandpdf';
import { handleViewFinalPDF, handlePrintFinalPDF } from '../../data/mergeandpdf';

const BRAND_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

const Addcategcont =styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
`
const Addcategform = styled.form`
  display: flex;
  margin:10px;
`
const Displaydiv1 = styled.div`

`
const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom:20px;
  margin-top:15px;
`
const FormEleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items:center;
`
const Button2Div =styled.div`
  display: flex;
  justify-content: end;
`

const AssetCategoryWrapper = styled.div`

`
const Label = styled.label`
    width: 140px;
    margin: 10px;
`

const SuggestSearchWrapper = styled.div`

`
const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
`
const CustomFileUploadButton = styled.label`
  /* Add your desired button styles */
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`
const BulkWrapper = styled.div`
  display: flex;
  align-items:center;
`

const FormItemdiv = styled.div`

`
const ViewModalWrapper = styled.div`
    font-size: 12px;
`
const CloseModalButton = styled.button`
  cursor: pointer;
  position: absolute;
  display: block;
  padding: 2px 5px;
  line-height: 20px;
  right: -10px;
  top: -10px;
  font-size: 24px;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid #cfcece;
`
const InputFile = styled.input`
  width: 180px;
  display: none;
`
const SearchDiv =styled.div`
  position: absolute;
  background-color: white;
  overflow-y: auto;
  height: 400px;
  z-index: 100;
  /* outline: 1px solid black; */
`

const SelectFileReset = styled.button`
  margin-right: 10px;
`
const ComplaintCategoryWrapper =styled.div`
  display: flex;
  align-items: center;
  justify-content:space-between;

`

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const tableFontSize = 18;


export default function CustomPaginationActionsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const {brandmaster} = useGetbrandmasterQuery("brandmasterList", {
    selectFromResult: ({ data }) => ({
      brandmaster: data?.entities
    }),
  })
  const {finalpdfform} =  useGetfinalpdfformQuery("finalpdfformList", {
    selectFromResult: ({ data }) => ({
      finalpdfform: data?.entities
    })
  })
  const [addNewBrandMaster] = useAddNewbrandmasterMutation();
  const [addBulkBrandMaster] = useAddBulkbrandmasterMutation();
  const [updateBrandMaster] = useUpdatebrandmasterMutation();
  const [deleteBrandMaster] = useDeletebrandmasterMutation();


  const inputFile = useRef(null);
  const [tabledata, setTabledata]= useState([]);
  const [editCategory, setEditCategory]=useState(null);
  const [editFormData, setEditFormData]=useState({});
  const [addBrandMasterData, setAddBrandMasterData] = useState({});
  const [assetCategory, setAssetCategory]=useState([]);
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(null);
  const [duplicateValues, setDuplicateValues] = useState();
  const [invalidValues, setInvalidValues] = useState();
  const [finalFile, setFinalFile] = useState([]);
  const [downloadData, setDownloadData] = useState({});
  const [bulkDataAdded, setBulkDataAdded] = useState(false);
  const [sentData, setSentData ]= useState(0);
  const [fileName, setFileName] = useState("");
  const [subject, setSubject] = useState({
    subjectValue: [...Array(tabledata.length).fill("")],
    subjectIndex: ""
  });
  const [validBrandId, setValidBrandId] = useState(false);
  const [brandIDFocus, setBrandIdFocus] = useState(false);

     // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onSubmit = async (event) =>{
    event.preventDefault();
    console.log(addBrandMasterData)
    try{
      let bodyobject ={"name":addBrandMasterData.name.trim()};
      const found = Object.values(brandmaster).some(el => el.name === addBrandMasterData.name);
   if(!found && addBrandMasterData?.name?.length ){
      const res = await addNewBrandMaster(bodyobject) ;
      alert(`New Brand ${bodyobject.name} added in masters.`)
      setAddBrandMasterData({});
      setSentData(sentData+1);
      }
    } catch(err){console.log(err)}
    setAddBrandMasterData({})
  }

  const onClickEdit = (e,k,row)=>{

    if((subject.subjectValue[k] === "") ||(subject.subjectValue[k] === undefined)){
      const temp = {...subject}
      temp.subjectIndex ="";
      setSubject(temp);
    }
    setEditCategory(k+1);

  }

  const onChangeAddBrandMaster = (event) =>{
    console.log(event.target.value)
    let temp ={...addBrandMasterData}
    temp = {...temp, [event.target.name]:event.target.value}
    setAddBrandMasterData(temp);

    // let temp ={...addDesgnData}
    // if(event.target.name?.length){
    //   temp = {...temp, [event.target.name]:event.target.value}
    // }
    // if(name?.length){
    //   temp = {...temp, [name]:newValue}
    // }
    // console.log(temp)
    // setAddDesgnData(temp);
  }

  const onChangeEditBrand = (event) =>{
    let temp ={...editFormData}    
    temp = {...temp, [event.target.name]:event.target.value}    
    setEditFormData(temp);
  }

  const handleButtonClick = () => {
    inputFile.current.click();
  }; 

  const handleEditFormSubmit = async (e) =>{
    e.preventDefault();
    try{
    setEditCategory(null);
    const id = tabledata[((page)*(rowsPerPage))+(editCategory-1)].id;
    let body ={}
    if (editFormData[`brandmaster${editCategory-1}`] !== undefined){ 
    body = {...body,"id":id, "name":editFormData[`brandmaster${((page)*(rowsPerPage))+(editCategory-1)}`].trim() }
    }
    const response = await updateBrandMaster(body)
    setSentData(body);
    }catch(err){}
  }  

  const handleCancelClick = (e,k) => {    
    const tempObject = {...subject};
    tempObject.subjectValue[k] = "";
    setEditCategory(null);
    setSubject(tempObject);
  };

  const handleDeleteClick = async (e,k,row) => {
    e.preventDefault();
    let body = {"id":row.id}
    const response = window.confirm(`Do you want to delete Brand "${row.name}"` )
    if(!response) return;
    alert(`Brand "${row.name}" deleted successfully`);
    const result = await deleteBrandMaster(body);
  };

  const assignFunction = (data) => {
    setFile(data);
    let reducedArray = [];
    let invalidValues = [];
    const tempArray = [...data];
    for(let val of tempArray){
      let tempObj = {name:val.name}
      if(BRAND_REGEX.test(val.name)){
      reducedArray.push(tempObj)
      }else{
        invalidValues.push(tempObj)
      }
    }
    setInvalidValues(invalidValues);
    const nameArray = Object.values(brandmaster).map(item => item.name);
    setDuplicateValues(reducedArray.filter(item => nameArray.includes(item.name)));   
    setFinalFile((reducedArray.filter(item => !nameArray.includes(item.name))));
  }

  const onBulkSubmit = async (e) =>{
    e.preventDefault();   
    const result = await addBulkBrandMaster(finalFile);
    if(result.data.acknowledged){
      setBulkDataAdded(true);      
    }
  }

  const deleteSelectFile = () => {
    if(inputFile.current){
      inputFile.current.value = "";
      inputFile.current.type = "text"; 
      inputFile.current.type = "file";
      setFile(null)
    }
  }

  const fileType = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"]
  const handleChangeBrand = (e) => {
    let selectedFile = e.target.files[0]
    if(selectedFile){
      if(fileType.includes(selectedFile.type)){
        setFileName(selectedFile.name)
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile)
        reader.onload = (e) => {
          setFileError(null);
          const workbook = XLSX.read(e.target.result, {type:'buffer' });
          const worksheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[worksheetName];
          const data = XLSX.utils.sheet_to_json(worksheet);
          assignFunction(data);
        }
      }else{
        setFileError("Please Select Correct File Type")
        setFile(null)
      }
    }else{
      setFileError("no file selected")
      setFile(null) 
    }
  } 

  useEffect(()=>{
    if(finalpdfform){
      const finalpdfformArray = Object.values(finalpdfform);
      setTabledata(finalpdfformArray);      
    }
  },[finalpdfform])

  useEffect(() => {
    setValidBrandId(BRAND_REGEX.test(addBrandMasterData.brandmaster));        
  }, [addBrandMasterData.brandmaster])

//Setting the download data for excel download.
useEffect(()=>{
  let finalDownloadData = [];
  let finalSortedDownloadData = [];
  const keyOrderArray = ["name"]
  let tempDownloadData = structuredClone(tabledata);
  for(let val of tempDownloadData ){
      let {_id, ...others} = val;
      others = {...others, ["name"]: val.name }
      finalDownloadData.push(others)
    }
    for(let value of finalDownloadData){
        let tempObject = {}
        for(let val of keyOrderArray){
            tempObject = {...tempObject, [val]:value[val]};
        }
        finalSortedDownloadData.push(tempObject);
    }
    setDownloadData(finalSortedDownloadData)
}, [tabledata])
 
   
  return (
    <>
   
    <Displaydiv1>
      <HeadingWrap>
        <Span>Final Pdf Forms</Span>
      </HeadingWrap>   

    <form onSubmit={handleEditFormSubmit}>

    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}  >
      <Table  aria-label="custom pagination table">
      <TableHead>
        <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"10%"}}}align="left">Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}} align="left">Form type</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}} align="left">Form No</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}} align="left">Store</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}} align="left">From Date</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}} align="left">To Date</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}} align="left">Status</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}} align="left">View Detail</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
              <TableRow key={key*2}>
                <TableCell style={{ fontSize: tableFontSize }} align="left">
                  {key+1}
                </TableCell>
                <TableCell style={{ fontSize: tableFontSize }} align="left">
                  {row?.formtype}
                </TableCell>
                <TableCell style={{ fontSize: tableFontSize }} align="left">
                  {row?.formno}
                </TableCell>
                <TableCell style={{ fontSize: tableFontSize }} align="left">
                  {row?.store}
                </TableCell>
                <TableCell style={{ fontSize: tableFontSize }} align="left">
                  {moment(row?.from_date).format("DD/MM/YYYY") }
                </TableCell>
                <TableCell style={{ fontSize: tableFontSize }} align="left">
                  {moment(row?.to_date).format("DD/MM/YYYY")}
                </TableCell>
                <TableCell style={{ fontSize: tableFontSize }} align="left">
                  {row?.status}
                </TableCell>
                <TableCell style={{ fontSize: tableFontSize }} align="left">
                  <Box display="flex">
                    <IconButton color="primary" onClick={() => handleViewFinalPDF(row?.filepaths)} >
                      <VisibilityIcon />
                    </IconButton>
                    <IconButton color="secondary" onClick={() => handlePrintFinalPDF(row?.filepaths)}>
                      <PrintIcon />
                    </IconButton>
                  </Box>
                </TableCell>

              </TableRow>  
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>
    </Displaydiv1>    
    </>
  );
}